import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppService } from 'src/app/services/app.service';
import { HttpResponse } from '@angular/common/http';
import { AppEnums } from 'src/app/enums/app.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-push-file-upload',
  templateUrl: './push-file-upload.component.html',
  styleUrls: ['./push-file-upload.component.scss'],
})
export class PushFileUploadComponent implements OnInit {
  @Input() azureFileLocation: string;
  @Input() azureFileName: string;
  @Output()
  emitFileUploadedEvent: EventEmitter<string> = new EventEmitter<string>();
  imagesFormGroup: FormGroup;
  aFile: File;
  contentType: string;
  fileExtension: string;
  finalFileName: string;
  allDataLoaded: boolean = true;
  sasToken: string;
  fileName: string;
  @Input() allowedFileExtentions: string[];

  constructor(private appService: AppService) {
    this.appService
      .makeGetRequest(`${environment.CORE_API_URL}/getSASkey`)
      ?.subscribe((sasToken) => {
        this.sasToken = sasToken.Payload;
      });
  }

  ngOnInit(): void {}
  onFileSelected(e) {
    this.aFile = e.target.files[0];
    this.contentType = this.aFile?.type;
    this.fileExtension = this.getFileExtension(this.aFile?.name);
  }
  getFileExtension(fileName: string): string {
    let arr = fileName.split('.');
    this.fileName = arr[0];

    return arr[arr.length - 1];
  }

  upload() {
    if (!this.allowedFileExtentions.includes(this.fileExtension)) {
      this.appService.showToastMessage(
        AppEnums.ToastTypeError,
        'Invalid File',
        `Only the following files are allowed:  ${this.allowedFileExtentions.toString()}`
      );
      return;
    }
    this.allDataLoaded = false;
    let fileName = `${this.fileName}.${this.fileExtension}`;

    let url = `${environment.CDN_BASE_URL}/${this.azureFileLocation}/${this.fileName}${environment.CDN_BASE_SAS_TOKEN}`;
    this.appService
      .uploadAzureImages(url, this.aFile, fileName, this.contentType)
      ?.subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            let res = event.status;
            if (res == 201) {
              this.allDataLoaded = true;
              this.emitFileUploadedEvent.emit(url);
              this.appService.showToastMessage(
                AppEnums.ToastTypeInfo,
                '',
                `File uploaded successfully!`
              );
            } else {
              this.allDataLoaded = true;

              this.appService.showToastMessage(
                AppEnums.ToastTypeWarning,
                '',
                `Operation return status ${event.status}`
              );
            }
          }
        },
        (err) => {
          this.allDataLoaded = true;
          this.appService.showToastMessage(
            AppEnums.ToastTypeError,
            '',
            `Could not upload the file!`
          );
        }
      );
  }
}
